// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120301/js/" + chunkId + "." + {"44":"3eb88318","225":"662fcc83","481":"7fbe1721","486":"6d6eaac0","770":"b8e8ff38"}[chunkId] + ".0.4031434730828116.chunk.js";
};